import React from 'react'
import PropTypes from 'prop-types'
import CellLink from './CellLink'
import { ChevronRightIcon } from '@heroicons/react/outline'
import { useHistory } from 'react-router-dom'
import useScreen from '../../../hooks/useScreen'
import clsx from 'clsx'
import { useNetworkStatus } from '../../../utils/networkStatus'

const CellRequestNumber = ({
    number,
    to,
    showIcon = true,
    requestType,
    requestShowType,
    requestStatus,
    translate,
}) => {
    const { push } = useHistory()
    const { isMobile, isTablet } = useScreen()
    const { isOffline } = useNetworkStatus()

    const isEnd = !showIcon && (isMobile || isTablet)
    const disableLink =
        ((requestType?.includes('PM') || requestType === 'closedRequest') &&
            isOffline) ||
        (requestShowType !== 'Repair' &&
            requestStatus !== 'Pending' &&
            isOffline)

    return (
        <>
            <div
                className={clsx(
                    'w-full h-full transition-all flex flex-row items-center border-0',
                    isEnd ? 'justify-end' : 'justify-between',
                )}
            >
                <CellLink
                    text={number}
                    to={to}
                    disableLink={disableLink}
                    isOffline={isOffline}
                    translate={translate}
                />
                {showIcon && (
                    <ChevronRightIcon
                        onClick={!disableLink ? () => push(to) : undefined}
                        className={clsx(
                            'w-6 h-6 md:hidden block',
                            disableLink
                                ? 'text-gray-400 cursor-not-allowed'
                                : 'text-black90',
                        )}
                    />
                )}
            </div>
        </>
    )
}

CellRequestNumber.propTypes = {
    number: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.any,
    ]),
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
    showIcon: PropTypes.bool,
    requestType: PropTypes.string,
    requestShowType: PropTypes.string,
    requestStatus: PropTypes.string,
    isOffline: PropTypes.bool,
    translate: PropTypes.string,
}

export default CellRequestNumber
